import Vue from "vue";
import { Location, Route, RawLocation } from "vue-router";

import { IsExerciseNavHandler, ExerciseNavState } from "@tt-app/models/exercise";
import { onTtBackAction } from "@tt-app/utils/internal/router";

import { BaseHandler } from "./base";

class ExerciseNavHandler extends BaseHandler implements IsExerciseNavHandler {
  getNewState(fallback: Location): ExerciseNavState {
    return {
      displayExitConfirmation: false,
      exitFallbackLocation: fallback,
      hasHandlerAttemptedNav: false,
      limitedModeUpdated: false,
      requireExitConfirmation: false
    };
  }

  exit<V extends Vue>(
    component: V,
    state: ExerciseNavState,
    updateState: (newState: ExerciseNavState) => void,
    routeParams?: any
  ) {
    const newState: ExerciseNavState = { ...state, hasHandlerAttemptedNav: true };
    updateState(newState);

    const ttLiveSessionActive = !!(component as any).session;

    onTtBackAction(component.$router, ttLiveSessionActive, state.exitFallbackLocation, routeParams);
  }

  onExitCancelled(state: ExerciseNavState): ExerciseNavState {
    return {
      ...state,
      displayExitConfirmation: false,
      hasHandlerAttemptedNav: false,
      limitedModeUpdated: false
    };
  }

  onExitConfirm<V extends Vue>(
    component: V,
    state: ExerciseNavState,
    updateState: (newState: ExerciseNavState) => void,
    routeParams?: any
  ): void {
    const newState: ExerciseNavState = { ...state, requireExitConfirmation: false };
    updateState(newState);

    const ttLiveSessionActive = !!(component as any).session;

    onTtBackAction(component.$router, ttLiveSessionActive, state.exitFallbackLocation, routeParams);
  }

  beforeRouteLeave<V extends Vue>(
    state: ExerciseNavState,
    updateState: (newState: ExerciseNavState) => void,
    to: Route,
    __: Route,
    next: (to?: RawLocation | false | ((vm: V) => any) | void) => void
  ): void {
    if (!state.requireExitConfirmation) {
      next();
      return;
    }

    const limitedModeUpdated = to.params.limitedMode === "true";

    next(false);
    updateState({ ...state, displayExitConfirmation: true, limitedModeUpdated });
  }
}

export const exerciseNavHandler = new ExerciseNavHandler();
